import React from "react";
import { Tag } from "antd";
import { useHistory } from "react-router-dom";

const MemoTagItem = ({ tagName, tid }) => {
  const history = useHistory();
  return (
    <div className='my-1'>
      <Tag
        style={{ cursor: "pointer" }}
        color='processing'
        onClick={(e) => {
          e.stopPropagation();
          history.push(`/dashboard/tag/${tid}`);
        }}
      >
        {tagName}
      </Tag>
    </div>
  );
};

export default MemoTagItem;
